import React from 'react';

import SearchableSelectRedux from 'components/shared/SearchableSelectRedux';
import { Field, reduxForm } from 'redux-form';

import FlatButton from 'material-ui/FlatButton';

import { AccentColor } from 'helpers/AccentColorHelper';
import * as validator from 'helpers/Validator';
import { colors } from 'helpers/ColorHelper';

let AssignTicketForm = props => {
  return (
    <form>
      <div className="row">
        <p style={{ padding: '0 15px' }}>
          You can assign this ticket by selecting a staff member from the drop down below.
        </p>
        <div className="row" style={{ textAlign: 'center' }}>
          <div className="col-xs-12">
            <Field
              name="assign"
              component={SearchableSelectRedux}
              filter={(searchText, key) => key.indexOf(searchText) !== -1}
              fullWidth
              grouped
              options={props.maintenanceStaff}
              placeholder="Assign To"
              variant="outlined"
              validate={[validator.required]}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: '15px', textAlign: 'center' }}>
          <FlatButton
            label="Assign"
            onClick={props.handleSubmit}
            primary
            hoverColor="grey"
            backgroundColor={AccentColor()}
            style={{
              color: colors.WHITE,
              height: '40px',
            }}
          />
        </div>
      </div>
    </form>
  );
};

AssignTicketForm = reduxForm({
  form: 'assign_ticket_form',
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(AssignTicketForm);

export default AssignTicketForm;
